<!-- src/app/navigation/admin-mobile-header/admin-mobile-header.component.html -->
<header class="admin-mobile-header">
  <!-- ⚠️ `onboardingAnchor` als STATISCHES Attribut, nicht als
       `[attr.onboardingAnchor]`: An einem Komponenten-Host ist das
       Property-Binding NG0306-gefährlich (siehe Kopf der anchor.registry). -->
  <xds-icon-button
    icon="fa-light fa-bars"
    size="lg"
    class="hamburger-button"
    data-testid="mobile-header-menu-button"
    onboardingAnchor="mobile-menu-toggle"
    [ariaLabel]="'TOGGLE_MENU' | translate"
    (clicked)="onMenuToggleClick()"
  ></xds-icon-button>

  <!-- Telefonstufe: der Seitenname steht hier, weil der Seitenkopf darunter entfällt
       (Rahmen-Diät). `aria-hidden`, weil es eine optische Wiederholung ist — das echte
       `h1` bleibt im Seitenkopf und damit in `main`, sodass Überschriften-Reihenfolge
       und „genau ein h1 pro Seite" unangetastet bleiben. -->
  <!-- Der Anker sitzt am gemeinsamen Elternteil, NICHT an einer der drei
       Unterzeilen: die schliessen einander per `*ngIf` aus, ein Anker an einer
       von ihnen waere je nach Datenlage da oder weg. Nur auf der Telefonstufe
       vorhanden (`showsPageTitle()`) — Tour-Schritte darauf brauchen `skipIf`. -->
  <div
    *ngIf="showsPageTitle(); else brandLogo"
    class="header-page-context"
    onboardingAnchor="planner-week-title"
    aria-hidden="true"
  >
    <div class="header-page-title">{{ context().titleKey | translate }}</div>
    <div *ngIf="contextText() as line" class="header-page-subline">{{ line }}</div>
    <div *ngIf="!contextText() && context().subKey as subKey" class="header-page-subline">
      {{ subKey | translate }}
    </div>
    <div *ngIf="!contextText() && !context().subKey && context().subText as subText"
         class="header-page-subline">{{ subText }}</div>
  </div>

  <ng-template #brandLogo>
    <div class="header-title-logo">
      <picture>
        <source
          srcset="assets/img/icons/web-app-logo/logo-dark.svg"
          media="(prefers-color-scheme: dark)"
        />
        <img
          src="assets/img/icons/web-app-logo/logo-light.svg"
          alt="Logo"
          class="mobile-header-logo-icon"
          width="40"
          height="40"
        />
      </picture>
      <img
        src="assets/img/logo-text.svg"
        alt="FixPlaner"
        class="mobile-header-logo-text"
      />
    </div>
  </ng-template>

  <div class="header-actions">
    <app-top-actions-bar [compact]="true"></app-top-actions-bar>
  </div>
</header>
